import { AxiosError } from 'axios';

export function getUserFriendlyErrorMessage(error: unknown): string {
  if (error instanceof AxiosError) {
    if (!error.response) {
      return "Connection lost. Your recording is saved \u2014 we'll try again when you're back online.";
    }
    if (error.code === 'ECONNABORTED' || error.message?.includes('timeout')) {
      return 'This is taking longer than expected. Please check your connection and try again.';
    }
    const status = error.response?.status;
    if (status === 401 || status === 403) {
      return 'Your session has expired. Please sign in again.';
    }
    if (status === 429) {
      return "You're submitting too quickly. Please wait a moment and try again.";
    }
    if (status === 413) {
      return 'The file is too large. Please try a smaller file.';
    }
    if (status && status >= 500) {
      return 'Something went wrong on our end. Your recording is safe \u2014 please try again.';
    }
  }

  // Handle plain Error objects (e.g. from chat API's fetch-based assertOk)
  if (error instanceof Error) {
    const msg = error.message || '';
    if (msg === 'Network error' || msg.includes('Failed to fetch') || msg.includes('NetworkError')) {
      return "Connection lost \u2014 please check your internet and try again.";
    }
    if (msg.includes('timed out') || msg.includes('timeout')) {
      return 'This is taking longer than expected. Please check your connection and try again.';
    }
    if (msg.includes('401') || msg.includes('403') || msg.includes('Unauthorized')) {
      return 'Your session has expired. Please sign in again.';
    }
    if (msg.includes('429')) {
      return "You're submitting too quickly. Please wait a moment and try again.";
    }
    if (/\b5\d{2}\b/.test(msg)) {
      return 'Something went wrong on our end \u2014 please try again.';
    }
    if (msg.includes('413')) {
      return 'The file is too large. Please try a smaller file.';
    }
  }

  return "We couldn't send your message right now. Please try again.";
}
